import {
  NeedName,
  ProductCoverageName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";
import {
  isAkaCriticalIllnessCoInsuredSelected,
  isAkaCriticalIllnessInsuredSelected,
  isAkaGroupLifeDeathCoInsuredSelected,
  isAkaGroupLifeDeathSelected,
  isAkaGroupLifeIncapacityCoInsuredSelected,
  isAkaGroupLifeIncapacitySelected,
  isAkaGroupLifeTimeCoInsuredSelected,
  isAkaGroupLifeTimeSelected,
  isCriticalIllnessInsuranceSelected,
  isDeathInsuranceSelected,
  isDisabilityInsuranceSelected,
} from "Store/akaAdvice/mappers/mapToCartProducts/mapToCartProducts";

import { AdvicePriceCalculationResult } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { mapOneTimePayment } from "Store/akaAdvice/mappers/mapToPriceRequest/mapToDisabilityPriceReq";
import { isDefined } from "Utils/functions";
import { FormikProps } from "formik";
import { AkaAdvicePriceFormValues } from "../interfaces";
import { getMonthlyPrice } from "../utils";

export const getSelectedPrices = (
  isAdvisor: boolean,
  needName: NeedName,
  formProps: FormikProps<AkaAdvicePriceFormValues>,
  prices: AdvicePriceCalculationResult[],
): number[] => {
  switch (needName) {
    case NeedName.LIFE:
      return getSelectedLifePrices(formProps, prices);
    case NeedName.DISABILITY:
      return getSelectedDisabilityPrices(isAdvisor, formProps, prices);
    case NeedName.CRITICAL_ILLNESS:
      return getSelectedCriticalIllnessPrices(formProps, prices);
  }
};

export const getSelectedLifePrices = (
  formProps: FormikProps<AkaAdvicePriceFormValues>,
  prices: AdvicePriceCalculationResult[],
): number[] => {
  return [
    isAkaGroupLifeDeathSelected(formProps.values)
      ? getMonthlyPrice(
          ProductCoverageName.AKA_GROUP_LIFE_INSURED_DEATH,
          prices,
        )
      : 0,
    isAkaGroupLifeDeathCoInsuredSelected(formProps.values)
      ? getMonthlyPrice(
          ProductCoverageName.AKA_GROUP_LIFE_CO_INSURED_DEATH,
          prices,
        )
      : 0,
    isDeathInsuranceSelected(formProps.values)
      ? getMonthlyPrice(ProductCoverageName.DEATH, prices)
      : 0,
  ];
};

export const getSelectedDisabilityPrices = (
  isAdvisor: boolean,
  formProps: FormikProps<AkaAdvicePriceFormValues>,
  prices: AdvicePriceCalculationResult[],
): number[] => {
  const disabilityOneTimePaymentValue = mapOneTimePayment(
    isAdvisor,
    formProps.values,
  );
  return [
    isAkaGroupLifeIncapacitySelected(formProps.values)
      ? getMonthlyPrice(
          ProductCoverageName.AKA_GROUP_LIFE_INSURED_INCAPACITY_OF_WORK,
          prices,
        )
      : 0,
    isAkaGroupLifeIncapacityCoInsuredSelected(formProps.values)
      ? getMonthlyPrice(
          ProductCoverageName.AKA_GROUP_LIFE_CO_INSURED_INCAPACITY_OF_WORK,
          prices,
        )
      : 0,
    isAkaGroupLifeTimeSelected(formProps.values)
      ? getMonthlyPrice(
          ProductCoverageName.AKA_GROUP_LIFE_INSURED_TIME_LIMITED_DISABILITY_INTEREST,
          prices,
        )
      : 0,
    isAkaGroupLifeTimeCoInsuredSelected(formProps.values)
      ? getMonthlyPrice(
          ProductCoverageName.AKA_GROUP_LIFE_CO_INSURED_TIME_LIMITED_DISABILITY_INTEREST,
          prices,
        )
      : 0,
    isDisabilityInsuranceSelected(formProps.values)
      ? getMonthlyPrice(ProductCoverageName.DISABILITY_FLEX_PENSION, prices)
      : 0,
    isDisabilityInsuranceSelected(formProps.values) &&
    isDefined(disabilityOneTimePaymentValue)
      ? getMonthlyPrice(ProductCoverageName.DISABILITY_FLEX_CAPITAL, prices)
      : 0,
  ];
};

export const getSelectedCriticalIllnessPrices = (
  formProps: FormikProps<AkaAdvicePriceFormValues>,
  prices: AdvicePriceCalculationResult[],
): number[] => {
  return [
    isAkaCriticalIllnessInsuredSelected(formProps.values)
      ? getMonthlyPrice(ProductCoverageName.AKA_CRITICAL_ILLNESS, prices)
      : 0,
    isAkaCriticalIllnessCoInsuredSelected(formProps.values)
      ? getMonthlyPrice(
          ProductCoverageName.AKA_CRITICAL_ILLNESS_CO_INSURED,
          prices,
        )
      : 0,
    isCriticalIllnessInsuranceSelected(formProps.values)
      ? getMonthlyPrice(ProductCoverageName.CRITICAL_ILLNESS, prices)
      : 0,
  ];
};
